import { Component, Inject, Injector, Input, Optional } from '@angular/core';
import { EnhancedImageIconComponent } from './enhanced-image-icon.component';
import { ProfileService } from '../../../../auth/services/profile.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { PdfViewerService } from '../../../../../services/pdf-viewer.service';

@Component({
    selector: 'pdf-preview',
    templateUrl: './enhanced-image-icon.component.html',
    styleUrls: ['./enhanced-image-icon.component.css'],
    standalone: false
})
export class PdfPreviewComponent extends EnhancedImageIconComponent {
  @Input() quoteInput?: any;

  constructor(
    injector: Injector,
    profileService: ProfileService,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private pdfViewer: PdfViewerService,
    @Optional() @Inject('props') override props: any
  ) {
    super(injector);
    this.isAdmin = profileService.isAdmin;
  }

  isAdmin = false;

  override imageType: 'panoramic' | 'other' = 'panoramic';

  override getData(): any {
    if (this.data?.quote) {
      return this.data.quote;
    }

    return this.data;
  }

  override getImageType(): string {
    return 'PDF preview';
  }

  override getTooltip(): string {
    if (this.restricted) {
      return 'Restricted';
    }
    if (!this.hasImages) {
      return `No PDF preview available`;
    }

    return `View PDF preview`;
  }

  override getDisplayImages(): string[] {
    const data = this.getData();
    if (!data?.pdfPreview) {
      return [];
    }
    return [data.pdfPreview];
  }

  override getImageCount(): number {
    const data = this.getData();
    if (!data?.pdfPreview) {
      return 0;
    }
    return 1;
  }

  getPdfUrl(): string | null {
    const data = this.getData();
    return data?.pdf || null;
  }

override async open(): Promise<void> {
  const pdfUrl = this.getPdfUrl();

  if (!pdfUrl) {
    console.warn('No PDF url available');
    return;
  }

  // Rendered in-page by PdfViewerService: opening a blob: URL with
  // window.open() after an await is silently blocked by the popup blocker on
  // Safari mobile, and tablets do not render a PDF in a browser tab reliably.
  this.pdfViewer.open({
    title: this.translateService.instant('Quote'),
    source: { url: pdfUrl },
    loadingLabel: this.translateService.instant('Loading Quote...'),
    errorLabel: this.translateService.instant('Unable to open PDF'),
    download: {
      label: this.translateService.instant('Download PDF'),
      filename: `quote-${this.getData()?.id ?? ''}.pdf`,
    },
  });
}
}
